{
  "api_docs": "Documentação API",
  "search": "Pesquisar",
  "accept": "Aceitar",
  "create": "Criar",
  "submit": "Enviar",
  "delete": "Deletar",
  "cancel": "Cancelar",
  "enable": "Habilitar",
  "deploy": "Implementar",
  "scan": "Escanear",
  "download": "Baixar",
  "enabled": "Habilitado",
  "disable": "Desabilitar",
  "disabled": "Desabilitado",
  "export": "Exportar",
  "open_modal": "Abrir janela",
  "uuid": "UUID",
  "no_items": "Nenhum item",
  "not_applicable": "N/A",
  "requires_permission": "Você precisa da permissão {permission}. | Você precisa das seguintes permissões: {permission}",
  "copied_to_clipboard": "Copiado para a área de transferência!",
  "click_to_reveal": "Clique para revelar.",
  "reset_password": "Redefinir senha",
  "unknown": "Desconhecido",
  "no_results_found": "Nenhum resultado encontrado",
  "results": "sem resultados | 1 resultado | {n} resultados",
  "more_info": "Mais informações",
  "changes": "Mudanças",
  "metadata": "Metadados",
  "install": "Instalar",
  "manage": "Configurar",
  "edit": "Editar",
  "trigger": "Trigger",
  "never": "Nunca",
  "none": "Nenhum",
  "save": "Salvar",
  "import": "Importar",
  "success": "Sucesso",
  "info": "Informação",
  "warning": "Atenção",
  "danger": "Perigo",
  "reset": "Redefinir",
  "loading": "Carregando",
  "click_to_upload_image": "Clique para carregar uma nova imagem",
  "invalid_file_type": "Tipo de arquivo inválido",
  "information": "Informação",
  "description": "Descrição",
  "at_a_glance": "Resumo",
  "settings": "Configurações",
  "limits": "Limites",
  "admin_area": "Área do Administrador",
  "announcements": "Anúncios",
  "notifications": "Notificações",
  "clear_all": "Limpar Tudo",
  "formats": "Formatos:",
  "device_information": "Informação do Dispositivo",
  "permissions": "Permissões",
  "lock": "Bloquear",
  "unlock": "Desbloquear",
  "toggle": "Alternar",
  "reinstall": "Reinstalar",
  "suspend": "Suspender",
  "unsuspend": "Dessuspender",
  "here": "aqui",
  "users": "Usuários",
  "allocations": "Alocações",
  "database_hosts": "Host de Databases",
  "server_databases": "Server Databases",
  "locations": "Locais",
  "nests": "Nests",
  "eggs": "Eggs",
  "nodes": "Nodes",
  "servers": "Servidores",
  "admin": "Admin",
  "support_op": "Suporte OP",
  "something_went_wrong": "Algo ocorreu mal ao tentar realizar esta ação.",
  "daemon_connection_exception": "Houve um erro durante a tentativa de se comunicar com o daemon.",
  "server": {
    "no_servers": "Nenhum servidor",
    "no_servers_description": "Parece que você não tem servidores...",
    "no_servers_description_admin": "Parece que você não tem servidores. Você pode criar servidores a partir da área de administração clicando em {link}.",
    "hostname": "Hostname",
    "name": "Nome",
    "cpu": "CPU",
    "memory": "Memória",
    "swap": "Swap",
    "disk": "Disco",
    "node": "Node",
    "players": "Jogadores",
    "players_amount": "{current} / {max} Jogadores",
    "ip": "IP",
    "manage": "Gerenciar",
    "go_to_console": "Ir para o Console",
    "launch_sftp": "Abrir SFTP",
    "on_node": " no {node}",
    "gamemode": "Modo de jogo",
    "version": "Versão",
    "map": "Mapa",
    "resource_usage": "Uso de Recursos",
    "memory_usage": "Uso de Memória",
    "cpu_usage": "Uso de CPU",
    "status": {
      "unknown": "Desconhecido",
      "error": "Erro",
      "offline": "Offline",
      "online": "Online",
      "starting": "Iniciando",
      "stopping": "Parando",
      "migrating": "Migração pendente",
      "installing": "Instalando",
      "failed_install": "Falha ao instalar",
      "suspended": "Suspenso",
      "updating": "Atualizando",
      "moving": "Movendo",
      "creating_backup": "Criando backup",
      "deploying_backup": "Implantando o Backup"
    }
  },
  "release_types": {
    "alpha": "Alfa",
    "beta": "Beta",
    "release": "Lançamento"
  },
  "units": {
    "bytes": "B",
    "kilobytes": "KB",
    "megabytes": "MB",
    "gigabytes": "GB",
    "terabytes": "TB"
  },
  "dates": {
    "minute_abbreviation": "m",
    "minute": "minuto | minutos"
  },
  "labels": {
    "unknown": "Desconhecido",
    "latest": "Mais recente",
    "recommended": "Recomendado"
  },
  "languages": {
    "en": "Inglês",
    "ar_SA": "Árabe",
    "cs_CZ": "Tcheco",
    "da_DK": "Dinamarquês",
    "de_DE": "Alemão",
    "en_PT": "Inglês (Pirata)",
    "es_AR": "Espanhol (Argentina)",
    "es_EM": "Espanhol (Moderno)",
    "et_EE": "Estoniano",
    "fi_FI": "Finlandês",
    "fr_FR": "Francês",
    "hi_IN": "Hindu ",
    "hr_HR": "Húngaro",
    "it_IT": "Italiano",
    "ja_JP": "Japonês",
    "nl_NL": "Holandês",
    "no_NO": "Norueguês",
    "pl_PL": "Polonês",
    "pt_BR": "Português (Brasileiro)",
    "ro_RO": "Romeno",
    "ru_RU": "Russo",
    "ru_UA": "Ucraniano",
    "sv_SE": "Sueco",
    "tr_TR": "Turco",
    "ur_PK": "Urdu",
    "zh_CN": "Chinês (simplificado)"
  }
}
